import { useEffect, useState } from "react";
import { memberApi } from "../../lib/api";
import { toast } from "sonner";

// Espace Membres — montants en attente (liens Stripe ouverts) + bouton « Tout payer » (lien fusionné)
export function MemberBalance() {
  const [b, setB] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { memberApi.get("/member/balance").then((r) => setB(r.data)).catch(() => setB(null)); }, []);
  if (!b || !b.count) return null;
  const payAll = async () => {
    setBusy(true);
    try { const r = await memberApi.post("/member/balance/pay-all"); window.location.href = r.data.checkout_url; }
    catch (e) { toast.error(e?.response?.data?.detail || "Paiement impossible pour l'instant"); setBusy(false); }
  };
  return (
    <div className="mb-5 border border-[#C9A961]/50 bg-[#C9A961]/5 p-4" data-testid="member-balance">
      <p className="kz-mono text-[10px] tracking-[0.16em] uppercase text-white/40">Mes paiements en attente</p>
      <ul className="mt-2 space-y-1 text-sm text-white/80">
        {b.links.map((l) => <li key={l.session_id} className="flex justify-between gap-2" data-testid={`member-balance-${l.session_id}`}><span>{l.label}</span><b className="text-white">{l.amount.toFixed(2)} $</b></li>)}
      </ul>
      <div className="mt-3 flex flex-wrap items-center justify-between gap-2">
        <span className="text-white"><span className="text-white/60 text-sm">Total</span> <b className="text-lg" data-testid="member-balance-total">{b.total.toFixed(2)} $</b></span>
        <button onClick={payAll} disabled={busy} className="bg-[#D90429] hover:bg-[#b80322] text-white font-bold px-5 py-2 disabled:opacity-50" data-testid="member-pay-all">{busy ? "…" : b.count > 1 ? `💳 Tout payer — ${b.total.toFixed(2)} $` : `💳 Payer — ${b.total.toFixed(2)} $`}</button>
      </div>
      {b.count > 1 && <p className="mt-1 text-[11px] text-white/40">Un seul paiement sécurisé Stripe pour tous tes montants. Tu préfères Interac ? impactkb.bjj@gmail.com.</p>}
    </div>
  );
}
